$(document).ready(function(){
  $(window).on('load',function(){
    setTimeout(function(){
      $('.page-loader').fadeOut('fast');
    },1500);
  });
  $('.top-service-content').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
    $('.logo-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  $(".header__icon--account").on( "click", function(e) {
    e.preventDefault();
  	$(".account-content").slideToggle('fast');
  });
    $(".header__icon--search,.modal__toggle-close").on( "click", function(e) {
    e.preventDefault();
      $(this).toggleClass('active');
  	$(".search-modal").slideToggle('slow');
  });
  $(".announcement-close").on( "click", function(e) {
    e.preventDefault();
  	$(".announcementbar").slideUp('fast');
  });
    $(".menu-icon").on( "click", function(e) {
    e.preventDefault();
  	$(".navigation-menu").toggleClass('menu-active');
      $(this).parent().toggleClass('open');
  });
  $('.go-top').hide(0)

  $(window).scroll(function(){
    if($(this).scrollTop() > 100){
      $('.go-top').fadeIn(200);      
    } else {
      $('.go-top').fadeOut(300);
    }
  });
  $('.go-top').click(function(event) {
    event.preventDefault();

    $('html , body').animate({scrollTop: 0}, 1000);
  });
  $('.filter-button,.close-button').click(function(event) {
    event.preventDefault();
$('.toggle-filter').slideToggle('fast');
  });
$('.image-zoom')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });
    AOS.init({
      duration: 1200,
    });
});
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span>%D</span>' + '<span>%H</span>' + '<span>%M</span>' + '<span class="second">%S</span>'));
      });
    }

  });
}
jQuery(document).ready(function () {
    countDownIni('.countdown-content');
});
function megaMenu() {
    if (jQuery(window).width() < 992) {
        jQuery(".header__menu-item .submenu-links").each(function () {
            jQuery(this).css("margin-left", + 0 + "px");
        });
    } else {
        jQuery(".header__menu-item .submenu-links").each(function () {
            var menu = jQuery(".header > .container").offset();
            var dropdown = jQuery(this).parent().offset();
            var i = dropdown.left + jQuery(this).outerWidth() - (menu.left + jQuery(".header > .container").outerWidth());
            if (i > 0) {
                jQuery(this).css("margin-left", "-" + (i + 10) + "px");
            }
        });
    }
}
jQuery(document).ready(function () {
    megaMenu();
});
jQuery(window).resize(function () {
    megaMenu();
});
function linklist() {
    if (jQuery(window).width() < 992) {
      $(".footer-block__heading").on( "click", function(e) {
        e.preventDefault();
        $(this).next('.toggle').slideToggle('fast');
        $('.toggle').not($(this).next()).slideUp('medium');
      });
    }
}
jQuery(document).ready(function () {
    linklist();
});
jQuery(window).resize(function () {
    linklist();
});